"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var form_1 = require("../context/form");
var useUpdatePopoverPosition = function (popoverRef) {
    var _a = (0, form_1.useFormContext)(), files = _a.files, errors = _a.errors;
    (0, react_1.useEffect)(function () {
        var _a;
        if (popoverRef) {
            (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
        }
    }, [files, errors, popoverRef]);
};
exports.default = useUpdatePopoverPosition;
